import { useCallback, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { getParamTable, getParamTempTableFiltering, _setAxios } from 'lib/Helper';

const initialTableState = () => ({
    titleMobile: "nama",
    loading_first: false,
    loading: false,
    data: [],
    search: "",
    pagination: {
        current: 1,
        pageSize: 10,
        total: null,
    },
    sorting: [],
    filtering: {
    },
});

const useList = (tahunAjaran, semester) => {
    const [table, setTable] = useState({
        ...initialTableState(),
        filtering: {
            ...initialTableState().filtering,
            tahun_ajaran_id: tahunAjaran?.id,
            semester_id: semester?.id
        },
    });
    const [formState, setFormState] = useState({ data: {}, visible: false });
    const [filterState, setFilterState] = useState({ values: {
        ...table.filtering
    }, visible: false });
    const [deleteState, setDeleteState] = useState({visible: false, data: {}});
    const [approvalState, setApprovalState] = useState({visible: false, data: {}});
    const [detailState, setDetailState] = useState({visible: false, data: {}});

    const fetchTable = (isNew = false) => {
        const params = getParamTable("default", table);
        fetchData(params, isNew);
    };

    const fetchData = useCallback(async (params = {}, isNew = false) => {
        updateTableLoadingState(isNew);
        params.pagination.current = isMobile ? (isNew ? 1 : params.pagination.current) : params.pagination.current;

        const resp = await _setAxios("perizinan/siswa/table", "POST", params);
        if (resp.status) {
            setTimeout(() => {
                updateTableData(resp.data.list, params.pagination.current, isNew);
            }, 0);
        } else {
            resetTableLoadingState();
        }
    }, []);

    const updateTableLoadingState = (isNew) => {
        setTable(prev => ({
            ...prev,
            loading_first: isMobile ? isNew : false,
            loading: true
        }));
    };

    const resetTableLoadingState = () => {
        setTable(prev => ({ ...prev, loading_first: false, loading: false }));
    };

    const updateTableData = (data, current, isNew) => {
        const updatedData = isNew ? [] : table.data;
        const newCurrent = isMobile ? current + 1 : current;

        setTable(prev => ({
            ...prev,
            loading_first: false,
            loading: false,
            data: isMobile ? [...updatedData, ...data] : data,
            pagination: {
                ...prev.pagination,
                current: newCurrent,
                total: data.length,
            },
        }));
    };

    const setTempTableFilter = (name, value) => {
        setFilterState(prev => ({
            ...prev,
            values: { ...prev.values, [name]: value }
        }));
    };

    const setTableFilterFromTemp = () => {
        const params = getParamTempTableFiltering(table, filterState.values);
        fetchData(params, isMobile);
        modalFilter(false);
    };

    const modalFilter = (visible = false) => {
        setFilterState(prev => ({ ...prev, visible }));
    };

    const modalForm = (visible = false, data = {}) => {
        setFormState({ visible, data });
    };

    const modalDelete = (visible = false, data = {}) => {
        setDeleteState({ visible, data });
    };
    
    const modalApproval = (visible = false, data = {}) => {
        setApprovalState({ visible, data });
    };
    const modalDetail = (visible = false, data = {}) => {
        setDetailState({ visible, data });
    };

    return {
        table,
        formState,
        filterState,
        deleteState,
        approvalState,
        detailState,
        fetchTable,
        fetchData,
        setTempTableFilter,
        setTableFilterFromTemp,
        modalFilter,
        modalForm,
        modalDelete,
        modalApproval,
        modalDetail
    };
};

export default useList;
